<template>
    <div class="uEditor" ref="uEditor5">
        <div class="content">
            <vueUeditorWrap :config="config" v-model="detail" @ready="ready" :destroy="true"></vueUeditorWrap>
        </div>
    </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import $ from 'jquery'
const _url = window.location.origin
export default {
  name: 'uEditor',
  data() {
    return {
      editor: null, // uEditor实例
      detail: '',
      dialogFormVisible: false,
      config: {
        autoHeightEnabled: true, // 编辑器自动被内容撑高
        initialFrameHeight: 250, // 初始容器高度
        initialFrameWidth: 800, // 初始容器宽度
        autoFloatEnabled: true, // 工具栏悬浮
        initialContent: '', // 默认内容
        elementPathEnabled: false, // 元素路径
        allowDivTransToP: false,
        autoClearEmptyNode: true,
        // retainOnlyLabelPasted、pasteplain、filterTxtRules 去除复制样式实现无格式粘贴
        // retainOnlyLabelPasted: true, // 影响样式
        // pasteplain: true, // 影响图片上传
        // filterTxtRules: function() {
        //     return {
        //         //p标签没有内容直接删除及其字节点内容
        //         'p':function(node){
        //             //没有内容的p直接删掉
        //             if (!node.innerText()) {
        //                 node.parentNode.removeChild(node,node.innerText())
        //             }
        //         }
        //     }
        // }(),
        // wordCount: false, // 字数统计
        // enableAutoSave: false, // 自动保存
        // autoSyncData: false, // 自动同步编辑器要提交的数据
        // enableContextMenu: false, // 右键菜单
        // pasteplain: false, // 是否默认为纯文本粘贴
        // catchRemoteImageEnable: false, // 远程图片抓取关闭
        // imagePopup: false, // 图片操作的浮层开关，默认打开
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: `${_url}/api/ue/uploadEditorImage`,
        configUrl: `${_url}/api/ue/getConfig`,
        UEDITOR_HOME_URL: '/UEditor/', // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        toolbars: [
          [
            'source', // 源代码
            '|',
            'undo', // 前进
            'redo', // 后退
            '|',
            'fontfamily', // 字体
            'fontsize', // 大小
            'bold', // 加粗
            'forecolor', // 字体颜色
            'italic', // 斜体
            'underline', // 下划线
            '|',
            'justifyleft', // 左对齐
            'justifycenter', // 居中
            'justifyright', // 右对齐
            'lineheight', // 行间距
            '|',
            'insertunorderedlist', // 无序列表
            'directionalityltr', // 从左向右输入
            'directionalityrtl', // 从右向左输入
            '|',
            'simpleupload', // 图片
            'link' // 链接
          ]
        ],
        lineheight: ['1', '1.5', '1.75', '2', '3', '4', '5'] // 行高
      }
    }
  },
  mounted() {},
  methods: {
    insert(str) {
      this.editor.focus()
      this.editor.execCommand('inserthtml', str)
    },
    ready(editorInstance) {
      // console.log(document.getElementsByTagName("iframe"))
      let iframe = document.getElementsByTagName('iframe')
      let iframeUeditor = ''
      for (let i = 0; i < iframe.length; i++) {
        if (iframe[i].id.indexOf('ueditor') > -1) {
          iframeUeditor = iframe[i]
        }
      }
      if (iframeUeditor) {
        // iframeUeditor.contentDocument.body.style.padding = '50px 0 0 0'
        // iframeUeditor.contentDocument.body.style.boxSizing = 'border-box'
        iframeUeditor.contentDocument.body.style.margin = '0px 8px'
        // iframeUeditor.contentDocument.body.style.overflowY = 'hidden'
        let view = iframeUeditor.contentDocument.getElementsByClassName('view')
        for (let i = 0; i < view.length; i++) {
          view[i].classList.add('hidden')
        }
      }
      // console.log(document.getElementsByClassName('CodeMirror-scroll'))
      // let CodeMirror = document.getElementsByClassName('CodeMirror-scroll') ? document.getElementsByClassName('CodeMirror-scroll')[0] : ''
      // console.log(CodeMirror)
      // if (CodeMirror) {
      //     CodeMirror.style.padding = '50px 0 0'
      // }
      // console.log(CodeMirror)
      this.editor = editorInstance
      // console.log(`编辑器实例${editorInstance.key}: `, editorInstance)
      $(this.editor.body).on('click', '.ue_zj_btn', function() {
        $(this)
          .parent()
          .remove()
      })
    },
    init(content) {
      this.detail = content
    }
  },
  filters: {},
  watch: {
    detail() {
      // console.log(this.editor.getContent())
      this.$emit('getUEditorContent', this.detail)
    }
  },
  computed: {},
  components: {
    VueUeditorWrap
  }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.uEditor {
  .editor.options.elementPathEnabled {
    display: none !important;
  }
  .ue_zj_box {
    line-height: 1;
    width: calc(100% - 20px);
    padding: 10px;
    background: #f5f5f5;
    position: relative;
    .ue_zj_content {
      display: flex;
      .ue_zj_image {
        margin-right: 10px;
        position: relative;
        width: 82px;
        height: 60px;
        img {
          width: 100%;
          height: 100%;
        }
        .ue_zj_label {
          position: absolute;
          right: 0;
          bottom: 0;
          display: inline-block;
          padding: 3px 6px;
          color: #fff;
          font-size: 12px;
          background: #909399;
        }
      }
      .ue_zj_summary {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .ue_zj_title {
          .ue_zj_name {
            font-size: 14px;
            color: #303133;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .ue_zj_price {
          color: #f56c6c;
        }
      }
    }
    .ue_zj_btn {
      position: absolute;
      top: calc(50% - 10px);
      right: 0;
      margin: 0 10px;
      width: 20px;
      height: 20px;
      display: none;
      /*background: url(./default/images/zj_icon/del.png);*/
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  .ue_zj_box {
    &:hover {
      .ue_zj_btn {
        display: block;
      }
    }
  }
  .ue_btn {
    margin-left: 8px;
    .el-button {
      display: block;
      margin: 0;
      width: 154px;
      height: 54px;
      border-radius: 0;
      border-width: 0;
      border: 1px solid #dddddd;
    }
    .el-button ~ .el-button {
      border-top: 0px solid #dddddd;
    }
  }
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    > div {
      width: 100%;
      height: 100%;
    }
  }
  .edui-default .edui-editor,
  .edui-default .edui-editor-iframeholder {
    width: 100% !important;
    height: 100%;
  }
  .edui-default .edui-editor-iframeholder {
    // height: 82% !important;
  }
  .edui-editor::before {
    content: '';
    height: 48px;
    display: block;
  }
  .edui-editor-toolbarbox {
    position: absolute !important;
    width: 100%;
    z-index: 1000;
    top: 0;
  }
  .edui-default .edui-editor {
    box-sizing: border-box;
  }
  .el-dialog {
    min-height: 500px;
    line-height: 1 !important;
    img {
      max-width: 100% !important;
    }
    .preview {
      min-height: 500px;
    }
    .noPreview {
      height: 500px;
      text-align: center;
      line-height: 500px;
      color: #ccc;
    }
  }
  .view {
    padding-top: 50px !important;
    .zxr {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
